import { useSettingsStore } from '../../stores';
import { getEmpCode } from '../../utils/auth';

/**
 * 获取用户信息
 */
export const getUserInfo = async () => {
  const { settings } = useSettingsStore();
  return settings.user.getUserInfo?.(getEmpCode() || '');
};
